import React, { useMemo } from "react";

import { isThisYear } from "date-fns";

import { Button } from "~/ui";
import { DateSelector } from "~/ui/legacyFellowIndex";

import eventFormStyles from "./EventForm.module.css";

function DateInputValueDisplay({
	date,
	format,
	disabled,
}: {
	date: Date;
	format: "long" | "short";
	disabled?: boolean;
}) {
	const label = useMemo(() => {
		const dateIsThisYear = isThisYear(date);
		let options: Intl.DateTimeFormatOptions = { day: "numeric", month: format };

		if (!dateIsThisYear) {
			options = {
				...options,
				year: "numeric",
			};
		}

		if (format === "long") {
			options = {
				...options,
				weekday: "long",
			};
		}

		return new Intl.DateTimeFormat("en-US", options).format(date);
	}, [date, format]);

	return (
		<Button variant="secondary" size="normal" className={eventFormStyles.dateInput} type="button" disabled={disabled}>
			{label}
		</Button>
	);
}

interface DateInputProps {
	date: Date;
	setDate: (date: Date) => void;
	labelFormat: "long" | "short";
	disabled?: boolean;
}

export default function DateInput({ date, setDate, labelFormat, disabled }: DateInputProps) {
	if (disabled) return <DateInputValueDisplay date={date} format={labelFormat} disabled />;

	return (
		<DateSelector date={date} setDate={setDate}>
			<DateInputValueDisplay date={date} format={labelFormat} />
		</DateSelector>
	);
}
